import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { AbstractControl, AbstractControlOptions, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ModalMessageComponent } from 'src/app/shared/components/modals/modal-message/modal-message.component';
import { DatosEmpleadosService } from '../../../services/mantenimiento/datos-empleados.service';
import { formEmpleadoValidators, validacionCentroEmpleado } from '../../../services/mantenimiento/customValidatorsEmpleados';
import { SpinnerModalComponent } from 'src/app/shared/components/others/spinner-modal/spinner-modal.component';
import { DropDownSingleConIdComponent } from 'src/app/shared/components/sqp-components/sqpDesplegable/components/drop-down-single-con-id/drop-down-single-con-id.component';
import { EmpresasModel } from 'src/app/pages/configuracion/maestros/empresas/models/empresas-model';
import { RecuperaEmpresasApiService } from 'src/app/pages/configuracion/maestros/empresas/services/recupera-empresas-api.service';
import { FormularioDocumentoService } from 'src/app/pages/configuracion/Envios/documentos/services/formulario-documento.service';
import { LoginService } from 'src/app/pages/login/services/login.service';
import { esAdminOSupervisor } from 'src/app/pages/login/services/es-admin-o-supervisor';
import { FiltroEmpleado } from 'src/app/shared/models/filtros';
import { filter, startWith, take } from 'rxjs/operators';

const EMAIL_PATTERN = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

@Component({
  selector: 'app-empleados-modal',
  templateUrl: './empleados-modal.component.html',
  styleUrls: ['./empleados-modal.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmpleadosModalComponent implements OnInit {

  formEmpleado: FormGroup = new FormGroup({});
  isEditar: boolean = false;
  nuevo: boolean = false;
  // Flag to avoid reacting to the initial auto-emitted empresa selection from the dropdown
  inicializandoEmpresa: boolean = false;
  titulosArray: string[]=[
    "Detalle de empleado",
    "Edición de empleado",
    "Nuevo empleado"
  ]
  tituloModal: string = "";
  empresasList: string[] = [];
  centrosList: string[] = [];
  detallesIdentificativos: boolean = false;
  detallesDomicilio: boolean = false;
  detallesLaborales: boolean = false;
  detallesPersonales: boolean = false;
  detallesTiposContenido: boolean = false;
  empresas: EmpresasModel[];
  readonly modoEnvioSimple: boolean;
  readonly esPrincipalFirmante: boolean;
  /** Opt-in persistencia en maestro (solo Admin/Supervisor en Envio simple). */
  guardarDatosEmpleados = false;
  @ViewChild('DropDownCentro') dropDownCentro: DropDownSingleConIdComponent;

  constructor(private dialog: MatDialog,
              public dialogRef: MatDialogRef<any>,
              @Inject(MAT_DIALOG_DATA)
              public info: any,
              private fb: FormBuilder,
              private datosEmpresasApiService: RecuperaEmpresasApiService,
              public datosEmpleadosService: DatosEmpleadosService,
              private loginService: LoginService,
              private cdRef: ChangeDetectorRef,
              private snackBar: MatSnackBar,
              @Optional() private formularioDocumentoService: FormularioDocumentoService) {
    this.modoEnvioSimple = this.info?.modoEnvioSimple ?? false;
    this.esPrincipalFirmante = this.info?.esPrincipalFirmante ?? false;
  }

  get mostrarCheckboxGuardarEmpleados(): boolean {
    return this.modoEnvioSimple && esAdminOSupervisor(this.loginService);
  }

  /** Persistencia solicitada: checkbox marcado y rol Admin/Supervisor. */
  get debePersistirEnMaestro(): boolean {
    return this.mostrarCheckboxGuardarEmpleados && this.guardarDatosEmpleados;
  }

  ngOnInit(): void {
    this.getEmpresas();
    this.nuevo = this.info.nuevo;
    this.iniciarFormularioEmpleado();
    this.cambiarTituloModal();
    if (this.modoEnvioSimple) {
      this.editarEmpleado();
    }
  }

  cambiarTituloModal(){
    if(this.isEditar == false) this.tituloModal = `${this.nombre} ${this.apellido1}`;
    if(this.isEditar == true && this.nuevo == false) this.tituloModal = this.nombre;
    if(this.nuevo == true) this.tituloModal = this.tituloModal = this.titulosArray[2];
  }

  iniciarFormularioEmpleado(){
    const usarValidacionesEmpleados = !this.modoEnvioSimple || this.debePersistirEnMaestro;
    const req = usarValidacionesEmpleados ? [Validators.required] : [];
    const mailValidators = usarValidacionesEmpleados
      ? [Validators.required, Validators.pattern(EMAIL_PATTERN)]
      : [Validators.pattern(EMAIL_PATTERN)];
    const centroValidators = usarValidacionesEmpleados
      ? [validacionCentroEmpleado(() => this.formEmpleado, () => this.obtenerEmpresasParaValidacion())]
      : [];

    this.formEmpleado = this.fb.group({
      codigo:[this.info.empleado.codigo? this.info.empleado.codigo:''],
      tipoDocumento:[this.info.empleado.tipoDocumento],
      nif:[this.info.empleado.nif ? this.info.empleado.nif:'', ...req],
      fechaNacimiento:[this.info.empleado.fechaNacimiento],
      nombre:[this.info.empleado.nombre, req],
      apellido1:[this.info.empleado.apellido1, req],
      apellido2:[this.info.empleado.apellido2],
      nacionalidad:[this.info.empleado.nacionalidad],
      lugarNacimiento:[this.info.empleado.lugarNacimiento],
      estadoCivil:[this.info.empleado.estadoCivil],
      sexo:[this.info.empleado.sexo],
      tipoPersona:[this.info.empleado.tipoPersona],
      empresa:[this.info.empleado.codigoEmpresa ? `${this.info.empleado.codigoEmpresa}-${this.info.empleado.nombreEmpresa}`: null, req],
      centro:[this.info.empleado.codigoCentro ? `${this.info.empleado.codigoCentro}-${this.info.empleado.nombreCentro}`:null, centroValidators],
      provincia:[this.info.empleado.provincia],
      municipio:[this.info.empleado.municipio],
      codigoPostal:[this.info.empleado.codigoPostal],
      sigla:[this.info.empleado.sigla],
      numero:[this.info.empleado.numero],
      escalera:[this.info.empleado.escalera],
      piso:[this.info.empleado.piso],
      puerta:[this.info.empleado.puerta],
      mailPersonal:[this.info.empleado.mailPersonal, mailValidators],
      extensionTelefonoPersonal:[this.info.empleado.extensionTelefonoPersonal],
      telefonoPersonal:[this.info.empleado.telefonoPersonal],
      mailProfesional:[this.info.empleado.mailProfesional],
      extensionTelefonoProfesional:[this.info.empleado.extensionTelefonoProfesional],
      telefonoProfesional:[this.info.empleado.telefonoProfesional],
      fechaAlta:[this.info.empleado.fechaAlta, req],
      puestoTrabajo:[this.info.empleado.puestoTrabajo],
      categoria:[this.info.empleado.categoria],
      convenio:[this.info.empleado.convenio],
      codigoExterno: [this.info.empleado.codigoExterno]
    }
    , (usarValidacionesEmpleados
      ? ({ asyncValidators: [formEmpleadoValidators(this.datosEmpleadosService, this.info?.empleado)]} as AbstractControlOptions)
      : ({} as AbstractControlOptions)));

    if (this.info.nuevo || !this.info.empleado?.codigoEmpresa) {
      this.formEmpleado.controls['centro'].disable();
    } else {
      this.inicializandoEmpresa = true;
      this.setCentrosAsociados(this.info.empleado.codigoEmpresa, true);
    }
  }

  onToggleGuardarDatosEmpleados(checked: boolean): void {
    this.guardarDatosEmpleados = checked;
    this.aplicarValidacionesSegunPersistencia();
    this.cdRef.markForCheck();
  }

  private aplicarValidacionesSegunPersistencia(): void {
    if (!this.modoEnvioSimple) {
      return;
    }
    const usarValidacionesEmpleados = this.debePersistirEnMaestro;
    const req = usarValidacionesEmpleados ? [Validators.required] : [];
    const mailValidators = usarValidacionesEmpleados
      ? [Validators.required, Validators.pattern(EMAIL_PATTERN)]
      : [Validators.pattern(EMAIL_PATTERN)];
    const centroValidators = usarValidacionesEmpleados
      ? [validacionCentroEmpleado(() => this.formEmpleado, () => this.obtenerEmpresasParaValidacion())]
      : [];

    ['nif', 'nombre', 'apellido1', 'empresa', 'fechaAlta'].forEach(campo => {
      this.formEmpleado.controls[campo].setValidators(req);
      this.formEmpleado.controls[campo].updateValueAndValidity({ emitEvent: false });
    });
    this.formEmpleado.controls['mailPersonal'].setValidators(mailValidators);
    this.formEmpleado.controls['mailPersonal'].updateValueAndValidity({ emitEvent: false });
    this.formEmpleado.controls['centro'].setValidators(centroValidators);
    this.formEmpleado.controls['centro'].updateValueAndValidity({ emitEvent: false });

    if (usarValidacionesEmpleados) {
      this.formEmpleado.setAsyncValidators([
        formEmpleadoValidators(this.datosEmpleadosService, this.info?.empleado)
      ]);
    } else {
      this.formEmpleado.clearAsyncValidators();
    }

    // Si ya hay empresa elegida, refrescar centros (p.ej. empresas cargaron tarde)
    const empresaActual = this.formEmpleado.controls['empresa'].value;
    if (usarValidacionesEmpleados && empresaActual) {
      const codigoEmpresa = String(empresaActual).split('-')[0];
      if (this.obtenerEmpresasParaValidacion().some(e => e.codigoEmpresa == codigoEmpresa)) {
        this.setCentrosAsociados(codigoEmpresa, true);
      }
    }

    this.formEmpleado.updateValueAndValidity();
  }

  get codigo(){ return this.formEmpleado.controls['codigo']}
  get tipoDocumento(){ return this.formEmpleado.controls['tipoDocumento'].value}
  get nif(){ return this.formEmpleado.controls['nif'].value}
  get fechaNacimiento(){ return this.formEmpleado.controls['fechaNacimiento']}
  get nombre(){ return this.formEmpleado.controls['nombre'].value}
  get apellido1(){ return this.formEmpleado.controls['apellido1'].value}
  get apellido2(){ return this.formEmpleado.controls['apellido2'].value}
  get nacionalidad(){ return this.formEmpleado.controls['nacionalidad'].value}
  get lugarNacimiento(){ return this.formEmpleado.controls['lugarNacimiento'].value}
  get estadoCivil(){ return this.formEmpleado.controls['estadoCivil'].value}
  get sexo(){ return this.formEmpleado.controls['sexo'].value}
  get tipoPersona(){ return this.formEmpleado.controls['tipoPersona'].value}
  get empresa(){ return this.formEmpleado.controls['empresa'].value}
  get centro(){ return this.formEmpleado.controls['centro'].value}
  get provincia(){ return this.formEmpleado.controls['provincia'].value}
  get municipio(){ return this.formEmpleado.controls['municipio'].value}
  get codigoPostal(){ return this.formEmpleado.controls['codigoPostal'].value}
  get sigla(){ return this.formEmpleado.controls['sigla'].value}
  get numero(){ return this.formEmpleado.controls['numero'].value}
  get escalera(){ return this.formEmpleado.controls['escalera'].value}
  get piso(){ return this.formEmpleado.controls['piso'].value}
  get puerta(){ return this.formEmpleado.controls['puerta'].value}
  get mailPersonal(){ return this.formEmpleado.controls['mailPersonal'].value}
  get extensionTelefonoPersonal(){ return this.formEmpleado.controls['extensionTelefonoPersonal'].value}
  get telefonoPersonal(){ return this.formEmpleado.controls['telefonoPersonal'].value}
  get mailProfesional(){ return this.formEmpleado.controls['mailProfesional'].value}
  get extensionTelefonoProfesional(){ return this.formEmpleado.controls['extensionTelefonoProfesional'].value}
  get telefonoProfesional(){ return this.formEmpleado.controls['telefonoProfesional'].value}
  get fechaAlta(){ return this.formEmpleado.controls['fechaAlta']}
  get puestoTrabajo(){ return this.formEmpleado.controls['puestoTrabajo'].value}
  get categoria(){ return this.formEmpleado.controls['categoria'].value}
  get convenio(){ return this.formEmpleado.controls['convenio'].value}
  get codigoExterno(){ return this.formEmpleado.controls['codigoExterno'].value}

  isCampoValido(campo:string){
    return this.formEmpleado.controls[campo].errors && this.formEmpleado.controls[campo].touched;
  }

  editarEmpleado(){
    this.isEditar = true;
    this.detallesDomicilio = true;
    this.detallesIdentificativos = true;
    this.detallesLaborales = true;
    this.detallesPersonales = true;
    this.cambiarTituloModal();
  }

  guardarCambiosEmpleado(){
    if (this.formEmpleado.pending) {
      // Esperar a que termine la validacion async (NIF duplicado); startWith cubre carrera de estado
      this.formEmpleado.statusChanges.pipe(
        startWith(this.formEmpleado.status),
        filter(status => status !== 'PENDING'),
        take(1)
      ).subscribe(() => this.guardarCambiosEmpleado());
      return;
    }
    if (this.formEmpleado.invalid) {
      this.mostrarErroresValidacionFormulario();
      return;
    }
    let objetoEmpleado: any = this.formEmpleado.getRawValue();
    if (this.empresa) {
      const [codigoEmpresa, ...nombreEmpresaParts] = this.empresa.split('-');
      objetoEmpleado.codigoEmpresa = codigoEmpresa;
      objetoEmpleado.nombreEmpresa = nombreEmpresaParts.join('-');
    }
    if (this.centro) {
      const [codigoCentro, ...nombreCentroParts] = this.centro.split('-');
      objetoEmpleado.codigoCentro = codigoCentro;
      objetoEmpleado.nombreCentro = nombreCentroParts.join('-');
    }

    delete objetoEmpleado.empresa;
    delete objetoEmpleado.centro;

    if (this.modoEnvioSimple) {
      objetoEmpleado = this.normalizarPayloadEnvioSimple(objetoEmpleado);
      if (!this.debePersistirEnMaestro) {
        this.dialogRef.close({ empleado: objetoEmpleado, persistidoEnMaestro: false });
        return;
      }
      this.persistirEmpleadoEnMaestro(objetoEmpleado, true);
      return;
    }

    this.isEditar = !this.isEditar;
    this.persistirEmpleadoEnMaestro(objetoEmpleado, false);
  }

  private mostrarErroresValidacionFormulario(): void {
    this.detallesDomicilio = true;
    this.detallesIdentificativos = true;
    this.detallesLaborales = true;
    this.detallesPersonales = true;
    this.detallesTiposContenido = true;
    this.formEmpleado.markAllAsTouched();
    // OnPush: forzar pintado de errores (required, centro, empleadoExiste, etc.)
    this.cdRef.detectChanges();
    if (this.modoEnvioSimple) {
      this.snackBar.open(
        'Hay errores en el formulario. Revisa los campos marcados en rojo.',
        'Cerrar',
        { duration: 4000 }
      );
    }
  }

  private persistirEmpleadoEnMaestro(objetoEmpleado: any, modoEnvioSimple: boolean): void {
    const dialogRefSpinner = this.dialog.open(SpinnerModalComponent);
    // Alta = modal abierto como nuevo (sin codigoEmpleado de maestro al abrir)
    const esAlta = !!this.nuevo;
    if (esAlta) {
      objetoEmpleado.codigo = '';
    }
    if (objetoEmpleado.fechaNacimiento === '' || objetoEmpleado.fechaNacimiento == null) {
      objetoEmpleado.fechaNacimiento = null;
    }
    const request$ = esAlta
      ? this.datosEmpleadosService.addEmpleado(objetoEmpleado)
      : this.datosEmpleadosService.updateEmpleado(objetoEmpleado);

    request$.subscribe(
      () => {
        this.datosEmpleadosService.refreshEmpleados = true;
        if (modoEnvioSimple && esAlta && objetoEmpleado.nif) {
          this.obtenerEmpleadoPersistidoTrasAlta(objetoEmpleado, dialogRefSpinner);
          return;
        }
        dialogRefSpinner.close();
        if (modoEnvioSimple) {
          this.mostrarExitoYCerrar(objetoEmpleado, true);
          return;
        }
        const dialogRef = this.dialog.open(ModalMessageComponent, {
          data: {
            mensaje: 'Empleado guardado correctamente',
          },
        });
        dialogRef.afterClosed().subscribe(() => {
          this.dialogRef.close('OK');
        });
      },
      error => {
        dialogRefSpinner.close();
        console.error('error', error);
        const dialogRef = this.dialog.open(ModalMessageComponent, {
          data: {
            mensaje: 'Error. El empleado no se ha guardado',
            alert: true
          },
        });
        if (modoEnvioSimple) {
          // Spec: conservar datos ya aplicados al store aunque falle la API
          dialogRef.afterClosed().subscribe(() => {
            this.dialogRef.close({ empleado: objetoEmpleado, persistidoEnMaestro: false });
          });
        }
      }
    );
  }

  private obtenerEmpleadoPersistidoTrasAlta(objetoEmpleado: any, dialogRefSpinner: MatDialogRef<unknown>): void {
    const nif = String(objetoEmpleado.nif ?? '').toUpperCase();
    const filtroNif: FiltroEmpleado = {
      text: 'Nif',
      listaValores: [objetoEmpleado.nif]
    };
    this.datosEmpleadosService.refreshEmpleados = true;
    this.datosEmpleadosService.getEmpleados([filtroNif], 1).subscribe({
      next: empleados => {
        dialogRefSpinner.close();
        const empleadoPersistido =
          empleados?.find(emp => String(emp.nif ?? '').toUpperCase() === nif) ??
          empleados?.[0] ??
          objetoEmpleado;
        this.mostrarExitoYCerrar(empleadoPersistido, true);
      },
      error: () => {
        dialogRefSpinner.close();
        this.mostrarExitoYCerrar(objetoEmpleado, true);
      }
    });
  }

  private mostrarExitoYCerrar(empleado: any, persistidoEnMaestro: boolean): void {
    const dialogRef = this.dialog.open(ModalMessageComponent, {
      data: {
        mensaje: 'Los datos de empleado se han actualizado correctamente',
      },
    });
    dialogRef.afterClosed().subscribe(() => {
      this.dialogRef.close({ empleado, persistidoEnMaestro });
    });
  }

  private obtenerEmpresasParaValidacion(): EmpresasModel[] {
    return this.empresas ?? this.info?.empresas ?? [];
  }

  /**
   * Alinea el payload de Envio simple con el flujo regular de grid:
   * campos vacios como cadena vacia en lugar de null/undefined.
   * Excepcion: fechaNacimiento vacia va como null (contrato API addEmpleado).
   */
  private normalizarPayloadEnvioSimple(empleado: any): any {
    const normalizado = Object.keys(empleado).reduce((acc: any, key: string) => {
      const value = empleado[key];
      acc[key] = value === null || value === undefined ? '' : value;
      return acc;
    }, {});

    // El grid siempre envia empresaCif como ""; el form no lo incluye como control
    if (normalizado.empresaCif == null || normalizado.empresaCif === '') {
      const empresa = this.obtenerEmpresasParaValidacion()
        .find(item => item.codigoEmpresa == normalizado.codigoEmpresa);
      normalizado.empresaCif = empresa?.cif ?? '';
    }

    if (normalizado.fechaNacimiento === '' || normalizado.fechaNacimiento == null) {
      normalizado.fechaNacimiento = null;
    }

    return normalizado;
  }

  getEmpresas(){
    this.datosEmpresasApiService.getEmpresas([], 0, {campoOrden:'', orden:''}).subscribe(
      next => {
        this.empresas = next;
        this.info.empresas = next;
        this.empresasList = next.map(x => `${x.codigoEmpresa}-${x.nombreEmpresa.toUpperCase()}`);
        const empresaActual = this.formEmpleado?.controls['empresa']?.value;
        if (empresaActual) {
          // Habia empresa elegida antes de cargar maestros: habilitar/validar centro
          this.setCentrosAsociados(String(empresaActual).split('-')[0], true);
        } else {
          this.formEmpleado.controls['centro']?.updateValueAndValidity();
        }
        this.cdRef.markForCheck();
      },
      error => {
        console.error();
      }
    )
  }

  mostrarDetalles(tipo: string){
    switch (tipo){
      case 'identificativos':
        this.detallesIdentificativos = !this.detallesIdentificativos;
      break
      case 'domicilio':
        this.detallesDomicilio = !this.detallesDomicilio;
      break
      case 'laborales':
        this.detallesLaborales = !this.detallesLaborales;
      break
      case 'personales':
        this.detallesPersonales = !this.detallesPersonales;
      break
      case 'tiposContenido':
        this.detallesTiposContenido = !this.detallesTiposContenido;
      break
    }
  }

  get tiposContenidoControls(): AbstractControl[] {
    const tiposContenido = this.formularioDocumentoService?.formularioDocumento?.get('tiposContenido') as FormArray | null;
    return tiposContenido?.controls ?? [];
  }

  get mostrarSeccionTiposContenido(): boolean {
    // En paso Envio, Editar otros datos es solo ficha de empleado.
    // Los tipos de contenido pertenecen a la configuracion del documento (paso Firmantes).
    return false;
  }

  setFecha(event:any, tipo:string){
    if(tipo=='alta') this.fechaAlta.setValue(event);
    if(tipo=='nacimiento') this.fechaNacimiento.setValue(event);
  }

  seleccionarEmpresa(event: any): void {
    if (event == null || event === '') {
      this.formEmpleado.controls['empresa'].setValue(null);
      this.centrosList = [];
      this.formEmpleado.controls['centro'].setValue(null);
      this.formEmpleado.controls['centro'].disable();
      return;
    }
    this.formEmpleado.controls['empresa'].setValue(event);
    const codigoEmpresaSeleccionada = event.split('-')[0];
    // Ignoramos el primer emit al inicializar la empresa
    if (this.inicializandoEmpresa) {
      this.inicializandoEmpresa = false;
      return;
    }
    this.setCentrosAsociados(codigoEmpresaSeleccionada);
  }

  setCentrosAsociados(codigoEmpresaSeleccionada: string, primeraCarga: boolean = false){
    this.centrosList=[];
    const empresaSeleccionada = this.obtenerEmpresasParaValidacion().find(x => x.codigoEmpresa == codigoEmpresaSeleccionada);
    if (!empresaSeleccionada) {
      this.formEmpleado.controls['centro'].disable();
      return;
    }
    empresaSeleccionada.centros.forEach(x => this.centrosList.push(`${x.codigoCentro}-${x.nombreCentro.toUpperCase()}`));
    this.formEmpleado.controls['centro'].enable();
    if(this.dropDownCentro && !primeraCarga){
      this.formEmpleado.controls['centro'].setValue(null);
      this.dropDownCentro.valorSeleccionado = null;
    }

  }

  seleccionarCentro(event:any){
    this.formEmpleado.controls['centro'].setValue(event);
  }
}
